import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
import { store } from "react-notifications-component";

const CouponCreating = () => {
	const [courseid, setCourseid] = useState("");
	const [coursename, setCoursename] = useState("");
	const [couponname, setCouponname] = useState("");

	const [courses, setCourses] = useState([]);

	const [price, setPrice] = useState();

	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				setCourses(data?.courses);
				console.log(data?.courses);
			});
	}, []);

	function couponcreation() {
		const notifyPopup = () => {
			store.addNotification({
				title: "Success!",
				message: "Form Submitted Successfully!",
				type: "success",
				background: "pink",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};
		fetch(BASE_URL + "/uploadcouponcourse", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
			body: JSON.stringify({ couponname, coursename, price, courseid }),
		})
			.then((res) => res.json())
			.then((dta) => {
				setCourseid("");
				setCoursename("");
				setCouponname("");
				setPrice("");
				notifyPopup();
				console.log(dta);
			});
	}

	return (
		<div className="d-flex flex-column mx-auto">
			<h2>Coupon creating small</h2>
			<input
				placeholder="Coupon Name"
				className="form-control mx-auto"
				type="text"
				value={couponname}
				onChange={(e) => {
					setCouponname(e.target.value);
				}}
				style={{ width: "50%", height: "20px", marginBottom: "20px" }}
			/>
			<input
				placeholder="Price"
				className="form-control mx-auto"
				type="text"
				value={price}
				onChange={(e) => {
					setPrice(e.target.value);
				}}
				style={{ width: "50%", height: "20px", marginBottom: "20px" }}
			/>

			<select
				className="mx-auto"
				name=""
				id=""
				onChange={(e) => {
					const newvalue = e.target.value.split(";");
					setCoursename(newvalue[1]);
					setCourseid(newvalue[0]);
				}}
				style={{ width: "50%", marginBottom: "20px" }}
			>
				<option value="">Select Course</option>
				{courses.map((val) => {
					return (
						<option value={val?._id + ";" + val?.name}>
							{val?.name}
						</option>
					);
				})}
			</select>

			<button
				className="btn btn-success mx-auto"
				onClick={couponcreation}
			>
				Create Coupon
			</button>
		</div>
	);
};

export default CouponCreating;
